import type { ProjectStatus } from "@acme/db/schema";
import * as m from "~/paraglide/messages.js";

/**
 * Delivered work or an exploration, said plainly on every card and at the head
 * of every case study.
 *
 * Never inferred: the client's own export asks that a concept keep its label
 * unless delivery is verified, because "delivered" claims work that shipped.
 */
export function ProjectStatusTag({
  status,
}: Readonly<{ status: ProjectStatus }>) {
  const isConcept = status === "concept";

  return (
    <span
      className={isConcept ? "project-status is-concept" : "project-status"}
    >
      {isConcept ? m.project_status_concept() : m.project_status_delivered()}
    </span>
  );
}
